import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import { ErrorMessage, GetCommonData, Params } from "../../../types";
import { DashboardCardData } from "../../../types/dashboard/dashboard";
import { handleApiError } from "../../../utils/errorHandler";

// get all
export const getAllDashboardDataAsync = createAsyncThunk<
  GetCommonData<DashboardCardData>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("admin-geo/getAllDashboardData", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.dashboard);

    return {
      data: data?.data?.data,
      length: data?.data?.totalLength,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get data fail");
    return rejectWithValue(error);
  }
});
